import { IModel, IAttribute } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { TypeFormat } from 'app/model/dataset/type-format';


@Metamodel.model({})
export class TextFormat extends TypeFormat {
    public static readonly MODEL: IModel;
    public static readonly COLUMN_DELIMETER: IAttribute;
    public static readonly ROW_DELIMETER: IAttribute;
    public static readonly SKIP_LINE_COUNT: IAttribute;
    public static readonly FIRST_ROW_AS_HEADER: IAttribute;
    public static readonly TREAT_EMPTY_AS_NULL: IAttribute;
    public static readonly ESCAPE_CHAR: IAttribute;
    public static readonly QUOTE_CHAR: IAttribute;
    public static readonly NULL_VALUE: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_ColumnDelimiter,
        templatable: true,
        association: 'COLUMN_DELIMETER'
    })
    public columnDelimiter?: string;

    @Metamodel.attribute({
        display: stringResources.Dataset_FileFormat_RowDelimiterFieldLabel,
        templatable: true,
        association: 'ROW_DELIMETER'
    })
    public rowDelimiter?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_NumberOfLinesToSkip,
        constraint: {
            whole: true,
            minimum: 0
        },
        templatable: true,
        association: 'SKIP_LINE_COUNT'
    })
    public skipLineCount?: number;

    @Metamodel.attribute({
        display: stringResources.ModelName_FirstRowAsHeader,
        templatable: true,
        association: 'FIRST_ROW_AS_HEADER'
    })
    public firstRowAsHeader?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_TreatEmptyAsNull,
        templatable: true,
        association: 'TREAT_EMPTY_AS_NULL'
    })
    public treatEmptyAsNull?: boolean = true;

    @Metamodel.attribute({
        display: stringResources.Dataset_FileFormat_EscapeCharFieldLabel,
        constraint: {
            pattern: new RegExp('^([^]|\\\\u([0-9a-f]){4})$')
        },
        templatable: true,
        association: 'ESCAPE_CHAR'
    })
    public escapeChar?: string;

    @Metamodel.attribute({
        display: stringResources.Dataset_FileFormat_QuoteCharFieldLabel,
        constraint: {
            pattern: new RegExp('^([^]|\\\\u([0-9a-f]){4})$')
        },
        templatable: true,
        association: 'QUOTE_CHAR'
    })
    public quoteChar?: string;

    @Metamodel.attribute({
        display: stringResources.NullValueFieldLabel,
        templatable: true,
        association: 'NULL_VALUE'
    })
    public nullValue?: string;
}
